import { render, staticRenderFns } from "./QuestionnaireDownloader.vue?vue&type=template&id=0806909c&"
import script from "./QuestionnaireDownloader.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireDownloader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports